import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from "react-router-dom";
import Modal from 'react-bootstrap/Modal'
import { API_BASE_URL } from '../../config';
import { connect } from 'react-redux'
const LoginFromModal = (props) => {
    const [state, setState] = useState({
        email: "",
        password: "",
        successMessage: null,
        error: { name: '', message: '' }, loader: false, success: false, checked: false, successeres: ''
    })
    useEffect(() => {
        //   alert("dsdfk")
        if (props.show) { setState((prev) => ({ ...prev, email: '', password: '' }));document.body.classList.add("showModal")}
    }, [props.show])
    const email = useRef(null)
    const pass = useRef(null)

    const handleSubmitClick = (e) => {
        e.preventDefault();

        if (/^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/.test(state.email)) {
            if (state.password !== "" && state.password.length >= 6) {
                setState((prev) => ({
                    ...prev, loader: true, successeres: ''
                }))

                var data = new FormData();
                data.append("action", "user_login")
                data.append("user_name", state.email)
                data.append("password", state.password)

                const requestOptions = {
                    method: 'post',
                    body: data
                };

                fetch(API_BASE_URL + 'data_process.php', requestOptions)
                    .then((response) => response.json())
                    .then(async (responseJson) => {


                        if (responseJson.success === "true") {
                            await setState((prev) => ({
                                ...prev, success: true,
                            }))
                            localStorage.setItem('login', JSON.stringify(responseJson));
                            await props.login(responseJson)

                        }
                        await setState((prev) => ({
                            ...prev, loader: false,
                        }))
                        await document.body.classList.remove("showModal");
                        props.handleResponce(responseJson)


                    })
                    .catch((error) => {

                        setState((prev) => ({
                            ...prev, loader: false,
                        }))

                    });
            } else {
                setState(prevState => ({
                    ...prevState,
                    error: { name: 'pass', message: "password must be 6 characters in length or longer" }
                }))
                pass.current.focus();
            }
        } else {
            setState(prevState => ({
                ...prevState,
                error: { name: 'email', message: "Please enter valid email" }
            }))
            email.current.focus();

        }
    }

    const handleChange = (e) => {
        setState(prevState => ({
            ...prevState,
            error: { name: '', message: '' }, successeres: ''
        }))
        const { name, value } = e.target
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))


    }

    return (

        <div class={props.show ? "jblListModal modalHere" : "jblListModal"}>
            <div class="jblListModal_Content" style={{ "height": "auto" }}>
                <div class="jblListModal_header">
                    <span class="close" onClick={() =>{document.body.classList.remove("showModal"); props.handleClose()}}>&times;</span>
                </div>
                <div class="jblListModal_Body" style={{ "padding": "15px" }}>
                    <h3>Login</h3>
                    <div class="form_wrapper" style={{"border": "0px","padding": "0px","width": "100%","margin": "0px","box-shadow": "none"}}>
                        <div class="form_container">
                            <form>

                                <div class="input_field">
                                    <label class="txt_title">Email*</label>
                                    <input type="email" name="email" value={state.email}
                                        onChange={handleChange} ref={email} />
                                    <p className={"errormessage"}>{state.error.name === "email" && state.error.message}</p>
                                </div>
                                <div class="input_field">
                                    <label class="txt_title">Password*</label>
                                    <input type="password" name="password" value={state.password}
                                        onChange={handleChange} ref={pass} />
                                    <p className={"errormessage"}>{state.error.name === "pass" && state.error.message}</p>
                                </div>


                                <div class="siteBtn_box">
                                    <input class="button" type="submit" value="Submit" onClick={handleSubmitClick} disabled={state.loader} style={{ opacity: state.loader ? 0.5 : 1 }} />
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
                </div>
                <div class={props.show ? "modal-backdrop fade show" : "modal-backdrop fade"}  onClick={() => {document.body.classList.remove("showModal");props.handleClose()}}></div>
        </div>
    )
}

//export default Home;
const mapStateToProps = (state) => {

    return {
        loginData: state.list.login
    };
};
const mapDispatchToProps = (dispatch) => {
    return {

        login: (data) => dispatch({ type: "LOGIN_INFO", payload: data })
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginFromModal));
//export default withRouter(LoginFromModal);